import { React, Fragment } from "react";
import PropTypes from "prop-types";
import VideoEmbed from "../../../../common/media/VideoEmbed";

function CourseLandingPageVideoPromo({ videoPromo }) {

  return (
    <Fragment>
      {
        videoPromo.id && 
          <div className="CourseLandingPage-video container-content">
            <div className="responsive-iframe-container">
              <VideoEmbed video={videoPromo} onProgress={() => {}} />
            </div>
          </div>
      }
    </Fragment>
  )
}

CourseLandingPageVideoPromo.propTypes = {
  videoPromo: PropTypes.object
};

export default CourseLandingPageVideoPromo;